module.exports = __webpack_public_path__ + "media/typy/osobowe@3x-c1e4de79.svg";